module.exports = __webpack_public_path__ + "static/media/home-2.73911f49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-2.jpg
// module id = 631
// module chunks = 0